import { render } from "./Glow18Project.vue?vue&type=template&id=2eb3d159&scoped=true"
const script = {}

import "./Glow18Project.vue?vue&type=style&index=0&id=2eb3d159&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eb3d159"]])

export default __exports__